<template>
    <v-container class="flex-column d-flex h-100">
        <div class="tab-section-name">Профиль</div>
        <div class="d-flex overflow-auto column-wrapper flex-wrap">
            <v-col sm="12">
                <form class="d-flex flex-wrap flex-column">
                    <v-row>
                        <div class="col-sm-12 col-md-6 col-xl-4">
                            <div>
                                <div class="label">Фамилия</div>
                                <v-text-field
                                    v-model="formData.last_name"
                                    v-validate="'required|alpha_dash'"
                                    :error-messages="errors.collect('Фамилия')"
                                    label="Фамилия"
                                    data-vv-name="Фамилия"
                                    validate-on-blur
                                    solo
                                    required
                                    color="purple darken-2"
                                    clearable
                                />
                            </div>
                            <div>
                                <div class="label">Имя</div>
                                <v-text-field
                                    v-model="formData.first_name"
                                    v-validate="'required|alpha_dash'"
                                    :error-messages="errors.collect('Имя')"
                                    label="Имя"
                                    data-vv-name="Имя"
                                    validate-on-blur
                                    solo
                                    required
                                    color="purple darken-2"
                                    clearable
                                />
                            </div>
                            <div>
                                <div class="label">Отчество</div>
                                <v-text-field
                                    v-model="formData.middle_name"
                                    v-validate="'required|alpha_dash'"
                                    :error-messages="errors.collect('Отчество')"
                                    label="Отчество"
                                    data-vv-name="Отчество"
                                    validate-on-blur
                                    solo
                                    required
                                    color="purple darken-2"
                                    clearable
                                />
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-xl-4">
                            <div>
                                <div class="label">Email</div>
                            </div>
                            <v-text-field
                                v-model="formData.email"
                                v-validate="'required|email'"
                                :error-messages="errors.collect('email')"
                                label="E-mail"
                                solo
                                color="purple darken-2"
                                data-vv-name="email"
                                clearable
                                validate-on-blur
                                required
                            />
                            <div>
                                <div class="label">Телефон</div>
                                <v-text-field
                                    v-model="formData.phone_number"
                                    v-validate="'required|min:12'"
                                    v-mask="mask"
                                    type="text"
                                    solo
                                    :error-messages="errors.collect('Номер телефона')"
                                    label="Номер телефона"
                                    color="purple darken-2"
                                    data-vv-name="Номер телефона"
                                    class="input-group--focused"
                                    required
                                    hint="введите номер в формате +38... или +7..."
                                    validate-on-blur
                                    clearable
                                />
                            </div>
                        </div>
                    </v-row>
                </form>
            </v-col>
        </div>
        <div class="flex-grow-1 align-end" style="display: flex;">
            <v-btn
                v-if="loaded"
                class="ml-auto m-3 color-white flex-grow-0"
                color="#4caf50"
                @click="submit"
            >Сохранить</v-btn>
        </div>
    </v-container>
</template>

<script>
    import 'moment/locale/ru'
    import { mask } from "vue-the-mask";

    export default {
        name: "UserProfile",
        directives: {
            mask
        },
        props: {
            data: {
                type: Object,
            },
        },

        data() {
            return {
                getData: {
                    id: '',
                    email: '',
                    mobile_phone: '',
                    profile: {
                        last_name: '',
                        first_name: '',
                        middle_name: '',
                    },
                },
                formData: {
                    id: '',
                    last_name: '',
                    first_name: '',
                    middle_name: '',
                    email: '',
                    phone_number: '',
                },
                mask: "+############",
                value: "+",
                loading: false,
                items: [],
                search: null,
                select: null,
                loaded: true,
                title: 'Загрузить изображение',
                imageUrl: '',
                cropImage: '',
                imageFile: '',
                openImageCrop: false,
                isSnackbar: true,
            }
        },

        mounted() {
            this.$validator.localize('ru', this.dictionary)
        },

        created() {
            this.getData = { ...this.data }
            this.formData.phone_number = this.getData.mobile_phone
            this.formData.first_name = this.getData.profile.first_name
            this.formData.middle_name = this.getData.profile.middle_name
            this.formData.last_name = this.getData.profile.last_name
            this.formData.email = this.getData.email
            this.formData.id = this.getData.id
        },
        methods: {

            submit() {
                this.$validator.validateAll().then(validated => {
                    if (!validated) {
                        return
                    }
                    this.updateUserProfile()
                })
            },

            updateUserProfile() {
                // this.formData.logo = this.imageUrl
                this.$store.dispatch('users/updateUserProfile', Object.assign({}, this.formData))
            },

            // Для поиска
            querySelections(v) {
                this.loading = true
                // Simulated ajax query
                setTimeout(() => {
                    this.items = this.states.filter(e => {
                        return (
                            (e || '')
                                .toLowerCase()
                                .indexOf((v || '').toLowerCase()) > -1
                        )
                    })
                    this.loading = false
                }, 500)
            },

            showModal() {
                this.openImageCrop = true
            },
            /**
             * Триггер события input'а при нажатии на аватарку.
             */
            pickFile() {
                this.$refs.image.click()
            },

            /**
             * Чтение файла.
             *
             * @param e event.
             */
            onFilePicked(e) {
                const files = e.target.files
                if (files[0] === undefined) {
                    this.removeAvatar()
                    return
                }

                let imageName = files[0].name
                if (imageName.lastIndexOf('.') <= 0) {
                    return
                }

                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener('load', () => {
                    this.cropImage = fr.result
                    this.imageFile = files[0]
                })
            },

            /**
             * Закрыть модальное окно.
             */
            closeModal() {
                this.openImageCrop = false
                this.cropImage = ''
            },

            /**
             * Обновить изображение.
             *
             * @param imageUrl Изображение в формате base64.
             */
            updateImage({ imageUrl }) {
                this.imageUrl = imageUrl
            },

            /**
             * Удалить изображение.
             */
            removeImage() {
                this.imageFile = ''
                this.imageUrl = ''
            },
        },
    }
</script>

<style scoped lang="scss">
    .label {
        font-weight: bold;
        text-align: left;
    }

    .padding {
        padding: 20px;
    }

    .v-input.company-search {
        margin-bottom: 28px;

        .v-input__control .v-input__slot {
            background-color: #fff !important;
        }
    }

    .column-wrapper {
        padding-left: 40px;
        padding-right: 40px;
    }

    .company-profile-phone {
        margin-bottom: 4px;
    }

    .profile-wrapper {
        padding-top: 37px;
    }

    i.v-icon.profile-photo.material-icons.theme--light {
        font-size: 70px;
    }

    .tab-section-name {
        width: 100%;
        color: #000;
        max-width: 250px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        white-space: normal;
        font-size: 20px;
        font-weight: 400;
        justify-content: flex-start;
        padding: 16px 16px 16px 50px;
    }
</style>
